import React from 'react';
import { IMAGES } from '../config/images';
import SectionHeader from './SectionHeader';

const partners = [
  { name: 'Algora', image: IMAGES.partners.algora },
  { name: 'EIB Nice', image: IMAGES.partners.eibNice },
  { name: 'EIB Cagnes', image: IMAGES.partners.eibCagnes },
  { name: 'EIB Pégomas', image: IMAGES.partners.eibPegomas },
  { name: 'EIB CIL', image: IMAGES.partners.eibCil },
  { name: 'CJPS', image: IMAGES.partners.cjps },
  { name: 'Arduino', logo: 'ARDUINO' },
  { name: 'Makeblock', logo: 'MAKEBLOCK' },
  { name: 'Lego Education', logo: 'LEGO' },
  { name: 'Scratch', logo: 'SCRATCH' },
  { name: 'Python', logo: 'PYTHON' },
];

const PartnersCarousel = () => {
  return (
    <section className="overflow-hidden border-t border-slate-100 bg-white py-14 sm:py-16">
      <div className="mx-auto mb-8 max-w-7xl px-4">
        <SectionHeader
          eyebrow="Ils nous font confiance"
          eyebrowKey="home.partners.eyebrow"
          title="Nos partenaires & technologies"
          titleKey="home.partners.title"
          subtitle={false}
          titleAs="h3"
          titleClassName="text-xl sm:text-2xl font-semibold mb-0"
          mb="mb-0"
          reveal
        />
      </div>

      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-12 bg-gradient-to-r from-white to-transparent sm:w-20" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-12 bg-gradient-to-l from-white to-transparent sm:w-20" />

        <div className="flex animate-scroll">
          {[...partners, ...partners].map((partner, index) => (
            <div
              key={`partner-${index}`}
              className="mx-3 flex h-14 w-36 flex-shrink-0 items-center justify-center sm:mx-5 sm:h-16 sm:w-40"
              title={partner.name}
            >
              {partner.image ? (
                <img
                  src={partner.image}
                  alt={partner.name}
                  className="max-h-9 max-w-full object-contain opacity-55 grayscale transition-[opacity,filter] duration-300 hover:opacity-90 hover:grayscale-0 sm:max-h-10"
                />
              ) : (
                <span className="select-none text-[11px] font-semibold tracking-[0.16em] text-slate-400 transition-colors hover:text-slate-600 sm:text-xs">
                  {partner.logo}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersCarousel;
